<template>
    <div class="modal-card card">
        <form>
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Acknowledge/Deny Warnings</h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <span class="fw-bold">
                    Certificate:
                </span>
                {{ modalData.commonName }}
                <br><br>
                <span class="fw-bold">
                    Warnings:
                </span>
                <div class="form-control">
                    <CodemirrorEditor :editorId="`ackDeny-${Math.random()}`" v-model="warnings" mode="application/json"
                        :refreshOn="true" :disabled="true" :readOnly="true"></CodemirrorEditor>
                </div>
                <!-- <input-field :inlineField="true" type="object" :inputType="'json'" v-model="warnings"
                        :editable="false" :showLabel="false"/> -->
            </div>
            <div class="card-footer float-end d-flex gap-3">
                <button class="btn btn-success" :disabled="updateInProgress" @click="onFormSubmit('acknowledge')">
                    <div v-if="updateInProgress" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        Acknowledge
                    </div>
                </button>
                <button class="btn btn-danger" :disabled="updateInProgress" @click="onFormSubmit('deny')">
                    <div v-if="deleteInProgress" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        Deny
                    </div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
// import InputField from "../../components/InputField.vue";
import CodemirrorEditor from "../../components/CodemirrorEditor.vue";
export default {
    components: { CodemirrorEditor },
    data() {
        return {
            error: "",
            updateInProgress: false,
            warnings: "",
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "AcknowledgeDenyWarnings",
    methods: {
        ...mapActions("aut", {
            ackDenyWarnings: "acknowledgeDenyWarnings",
        }),
        async onFormSubmit(ackDeny) {
            this.updateInProgress = true;
            let toastOptions = {
                message: "Warnings Acknowledged/Denied successfully.",
                type: "success"
            }
            await this.ackDenyWarnings({
                commonName: this.modalData.commonName,
                payload: {
                    acknowledgement: ackDeny
                }
            }).then(() => {
                this.$store.state.aut.getCertStatusTrigger = !this.$store.state.aut.getCertStatusTrigger
            }).catch((error) => {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                toastOptions = {
                    message: error || "Something went wrong while acknowledging/denying warnings. Please contact support.",
                    type: "error"
                }
                console.error("Error in acknowledge: ", this.error);
                return;
            }).finally(() => {
                this.updateInProgress = false;
                this.$store.dispatch("addToast", toastOptions);
            })
            this.$store.dispatch("hideModal");
        },
    },
    beforeMount() {
        this.warnings = JSON.stringify(this.modalData.warnings, null, 4);
    }
};
</script>

<style></style>